module.exports = __webpack_public_path__ + "img/scene5-5.307659d8.jpg";